<template>
  <div class="wait">
    <div class="wait-wrap">
      <p class="wait-text">
        <img src="@/assets/images/wait.svg" alt="Please Wait" />
      </p>
      <span v-for="n of 3" :key="n" class="wait-dot" :class="`wait-dot--${n}`" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScreenWait',
  props: {
    isVisible: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.wait {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: url(~@/assets/images/rower_bg_sp.jpg) center/cover no-repeat fixed;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  @include media() {
    background-image: url(~@/assets/images/rower_bg_pc.jpg);
  }
  &-wrap{
    display: flex;
    align-items: flex-end;
  }
  &-text{
    width: 96px;
    margin-right: 2px;
    @include media() {
      width: 105px;
    }
  }
  &-dot{
    display: block;
    width: 2px;
    height: 2px;
    margin: 0 2px;
    background: #333;
    border-radius: 50%;
    animation: wait-dot-anime 3s linear infinite both;
    @keyframes wait-dot-anime {
      0% {
        opacity: 0;
      }
      1% {
        opacity: 1;
      }
      49% {
        opacity: 1;
      }
      50% {
        opacity: 0;
      }
      100% {
        opacity: 0;
      }
    }
    &--1 {
      animation-delay: 0s;
    }
    &--2 {
      animation-delay: 0.5s;
    }
    &--3 {
      animation-delay: 1s;
    }
  }
}
</style>
